import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Vant, {Toast} from 'vant';
import 'vant/lib/index.css';
import commonApi from './commonApi'

// bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)


// element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// axio
import axios from 'axios'
Vue.prototype.$ajax = axios;
import global_ from './components/Global.vue'
Vue.prototype.GLOBAL = global_;
axios.defaults.baseURL = global_.BASE_URL;
axios.defaults.timeout = 15000;
Vue.prototype.$ajax = axios;

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.prototype.commonApi = commonApi;
// Vue.use(touch);

Vue.prototype.$yesnoFilter = () => {
  if(store.state.loadingWords == true){
    Toast.fail('数据加载失败，检查网络');
  }
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
